import React from "react";
import { LoaderSvg } from "../../assets/svg";

const ButtonLoader = ({ removeTheme }) => {
  return (
    <div
      className={`flex items-center justify-center rounded uppercase w-full ${
        removeTheme ? "text-themeBtn" : "text-white"
      } `}
    >
      <LoaderSvg className="mr-2 w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" />
      <span className="text-sm sm:text-xs">Loading...</span>
    </div>
  );
};

export default ButtonLoader;
